import React from 'react';
import SiteHeader from 'components/SiteHeader';
import UnconnectedSiteHeader from 'components/SiteHeader/SiteHeader';
import { useExperiments } from 'components/Experiment/useExperiments';
import { EOS_NEW_HEADER } from 'constants/monetateExperiments';

type SiteHeaderProps = React.JSX.IntrinsicAttributes & {
  decisions?: { [key: string]: string };
  isHomepage?: boolean;
  ssrRender?: boolean;
};

const ConnectedHeaderWithExperiment = (props: SiteHeaderProps) => {
  const { getDecisionById } = useExperiments();

  const showNewHeader =
    getDecisionById(EOS_NEW_HEADER.experiment).variant === EOS_NEW_HEADER.variant.showNewHeader;

  const fullProps = { ...props, showNewHeader };

  return <SiteHeader {...fullProps} />;
};

const SiteHeaderWrapper = (props: SiteHeaderProps) => {
  const { ssrRender } = props;

  if (ssrRender) {
    const fullProps = { ...props, staticRender: true };
    return <UnconnectedSiteHeader {...fullProps} />;
  }
  return <ConnectedHeaderWithExperiment {...props} />;
};

SiteHeaderWrapper.displayName = 'SiteHeaderWrapper';

export default SiteHeaderWrapper;
